import {interfaceText} from '../../../i18n/interfaceText';
// Static translation bindings: user-entered and stored data remain untouched.
import {localize,localizeRich,localizedDictionary} from "../../../i18n/runtime";
import {canUseCases,canUsePatients} from '../casesAccess';
import {patientText} from '../patientTexts';
import BrandSignet from './BrandSignet';
import React from 'react';
import {useEssenceSection} from './EssenceNavigation';
import { Link, useLocation } from 'react-router-dom';
import './fonts.css';
import './essence.css';
import './chrome-reference.css';

export function EssenceHeader({ user, account, language }) {
  const { search, pathname } = useLocation();
  const section=useEssenceSection();
  const patientsPage=/^\/praxis-tool\/(patients|prescriptions|solved-cases|intake-form|case-questions)(\/|$)/.test(pathname);
  const casesPage=/^\/praxis-tool\/cases(\/|$)/.test(pathname);
  const learningPage=pathname === '/praxis-tool/learning';
  const atlas = section ? section==='atlas' : new URLSearchParams(search).get('tab') === 'remedies';
  const de = user?.content_language === 'de';
  return <header className="ea-chrome ea-header" data-testid="essence-header" data-record-areas={Number(canUsePatients(user)) + Number(canUseCases(user))}>
    <Link className="ea-brand" to="/praxis-tool/home"><BrandSignet/><span>{localize("ui.aacc0ca191bca995","ESSENCE")}<small>{localize("ui.a9c019524932e6b7","ATLAS")}</small></span></Link>
    <nav aria-label={interfaceText('accessibility.mainNavigation')}>
      <Link aria-current={pathname === '/praxis-tool/home' ? 'page' : undefined} to="/praxis-tool/home">{patientText('homeNav',user?.content_language)}</Link>
      <Link aria-current={learningPage && atlas ? 'page' : undefined} to="/praxis-tool/learning?tab=remedies">{localize("ui.c58db8aaf2ef38d2","Atlas")}</Link>
      <Link aria-current={learningPage && !atlas ? 'page' : undefined} to="/praxis-tool/learning?tab=home">{localize("ui.a468526ed5efdcf3",de ? 'Lernen' : 'Study')}</Link>
      {canUsePatients(user) && <Link aria-current={patientsPage ? 'page' : undefined} to="/praxis-tool/patients">{patientText('patientsArea',user?.content_language)}</Link>}
      {canUseCases(user) && <Link aria-current={casesPage ? 'page' : undefined} to="/praxis-tool/cases">{patientText('casesArea',user?.content_language)}</Link>}
    </nav>
    <div className="ea-account">{user?.is_admin && language}{account}</div>
  </header>;
}
export {default as EssenceFooter} from './EssenceFooter';
